/**
 * 결재 칸 이름 중 소장 승인(V548 · HEAD)이 찍힐 칸 — 이름에 「소장」 이 든 칸, 없으면 마지막 칸. 나머지 한 칸이 MANAGER(V549).
 * 서버 {@code SafeJournalDocService.headCell} 과 같은 규칙이다. 종이(JournalPaper)와 목록의 「승인」 칸이 같이 쓴다.
 */
export function headCellOf(signers: string[]): number {
  for (let i = signers.length - 1; i >= 0; i--) if (signers[i]?.includes('소장')) return i;
  return signers.length - 1;
}
